import { render, staticRenderFns } from "./ElementList.vue?vue&type=template&id=10cec77d&scoped=true&"
import script from "./ElementList.vue?vue&type=script&lang=js&"
export * from "./ElementList.vue?vue&type=script&lang=js&"
import style0 from "./ElementList.vue?vue&type=style&index=0&id=10cec77d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cec77d",
  null
  
)

export default component.exports